import { render, staticRenderFns } from "./SuccessfulPayment.vue?vue&type=template&id=4f2073db&"
import script from "./SuccessfulPayment.vue?vue&type=script&lang=js&"
export * from "./SuccessfulPayment.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfulPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports